import { constants } from "@/lib/CONSTANTS.js";
import { totalSearchRecordService, groupSearchResultService } from "@/common/service/workflow/workflowService.js";

//TODO:: Need to fetch from common Mixin file
const getConsignementTypeByGroupId = (groupDetails, selectedGroupId) => {
  let selectedGroup = groupDetails.filter(group => group.id == selectedGroupId);
  return selectedGroup && selectedGroup.length && selectedGroup[0].consignmentType
    ? selectedGroup[0].consignmentType
    : "BOL";
};

const state = {
  isFirstPageLoad: true,
  resultsCache: {},
  totalRecords: 0,
  totalRecordsError: null,
  totalRecordsLoader: false,
  dateType: constants.pageSettings.exception.dateType[0].value, //default value
  dateRangeFilter: {
    start: null,
    end: null,
    pristine: true,
    touched: null,
    cleared: null
  },
  isDefaultDateRangeFilterSet: false,
  searchRecords: [],
  searchRecordsPage: 1,
  searchRecordsLoader: false,
  searchRecordsError: null,
  searchRecordItemsPerPage: constants.pageSettings.exception.groupSearchResultsPerPage
};

const mutations = {
  addToResultCache(state, contents) {
    for (let key of Object.keys(contents)) {
      state.resultsCache[key] = contents[key];
    }
  },
  resetResultCacheKeyData(state, data) {
    Object.assign(state.resultsCache, data);
  },
  setDateRangeFilter(state, selection) {
    const { startDate, endDate } = selection;
    state.dateRangeFilter.start = startDate;
    state.dateRangeFilter.end = endDate;
    state.dateRangeFilter.pristine = false;
    state.dateRangeFilter.touched = true;
    state.dateRangeFilter.cleared = startDate && endDate ? false : true;
  },
  setDefaultDateRangeAsTouched(state) {
    state.isDefaultDateRangeFilterSet = true;
  },
  setTotalRecordsCount(state, count) {
    state.totalRecords = count;
  },
  setGroupSearchResult(state, result) {
    state.searchRecords = result;
  },
  setGroupSearchCurrentPage(state, value) {
    state.searchRecordsPage = value;
  },
  setErrorState(state, param) {
    state[`${param.type}Error`] = param.error
      ? "hasError" in param.error
        ? param.error
        : { hasError: true, status: param.error.status, message: param.error.message }
      : null;
  },
  setLoadingState(state, param) {
    state[`${param.type}Loader`] = param.value;
  },
  setFirstPageLoadStatus(state, status) {
    state.isFirstPageLoad = status;
  },
  setDateTypeSelection(state, value) {
    state.dateType = value;
  }
};

const actions = {
  async fetchTotalRecordsCount({ commit, state, rootState }) {
    commit("setLoadingState", { type: "totalRecords", value: true });
    try {
      let count = state.resultsCache?.totalRecords;
      if (!count) {
        const queryParams = {
          groupId: rootState.userAccount.groupId,
          fromDate: state.dateRangeFilter?.start,
          toDate: state.dateRangeFilter?.end,
          dateType: state.dateType,
          exceptionTypes: rootState.groupErrorFilters.checkedErrorList.toString()
        };
        count = await totalSearchRecordService(queryParams);
        commit("addToResultCache", { totalRecords: count });
        commit("setLoadingState", { type: "totalRecords", value: false });
      }
      commit("setTotalRecordsCount", count);
      commit("setErrorState", { type: "totalRecords", error: "" });
    } catch (error) {
      commit("setTotalRecordsCount", 0);
      commit("addToResultCache", { totalRecords: 0 });
      commit("setErrorState", { type: "totalRecords", error });
      commit("setLoadingState", { type: "totalRecords", value: false });
    }
  },
  async fetchGroupSearchResult({ commit, state, rootState }) {
    commit("setLoadingState", { type: "searchRecords", value: true });
    try {
      // let rawResult, results = state.resultsCache?.searchRecords;
      let rawResult, results;
      // if (!results || results.length === 0) {
      const queryParams = {
        groupId: rootState.userAccount.groupId,
        fromDate: state.dateRangeFilter?.start,
        toDate: state.dateRangeFilter?.end,
        dateType: state.dateType,
        page: state.searchRecordsPage - 1,
        size: state.searchRecordItemsPerPage,
        exceptionTypes: rootState.groupErrorFilters.checkedErrorList.toString(),
        consignmentType: getConsignementTypeByGroupId(
          rootState.userAccount.userGroupDetails,
          rootState.userAccount.groupId
        )
      };

      rawResult = await groupSearchResultService(queryParams, true);
      if (rawResult.status > 200 && rawResult.status <= 299) {
        results = [];
        commit("setErrorState", {
          type: "searchRecords",
          error: { hasError: false, status: rawResult.status, message: rawResult.statusText }
        });
      } else {
        results = await rawResult.json();
      }
      commit("addToResultCache", { searchRecords: results });
      commit("setLoadingState", { type: "searchRecords", value: false });
      if (state.isFirstPageLoad) commit("setFirstPageLoadStatus", false);
      // }
      commit("setGroupSearchResult", results);
      if (rawResult.status === 200) commit("setErrorState", { type: "searchRecords", error: "" });
    } catch (error) {
      commit("setGroupSearchResult", []);
      commit("addToResultCache", { searchRecords: [] });
      commit("setErrorState", { type: "searchRecords", error });
      commit("setLoadingState", { type: "searchRecords", value: false });
      if (state.isFirstPageLoad) commit("setFirstPageLoadStatus", false);
    }
  },
  invokeGroupSearchPagination({ commit, dispatch, state }, value) {
    if (value !== state.searchRecordsPage) {
      commit("resetResultCacheKeyData", { searchRecords: [] });
      commit("setGroupSearchResult", []);
      commit("setGroupSearchCurrentPage", value);
      dispatch("fetchGroupSearchResult");
    }
  },
  invokeDateRangeSelection({ commit, dispatch, rootState }, dateRangeSelection) {
    if (state.searchRecordsPage !== 1) {
      commit("setGroupSearchCurrentPage", 1);
    }
    dispatch("resetCacheResults");
    dispatch("resetResults");
    commit("setDateRangeFilter", dateRangeSelection);
    if (rootState.userAccount && rootState.userAccount.groupId && rootState.userAccount.groupId.length > 0) {
      dispatch("fetchTotalRecordsCount");
      dispatch("fetchGroupSearchResult");
    }
  },
  invokeDqepopup({ commit, dispatch, rootState }) {
    if (state.searchRecordsPage !== 1) {
      commit("setGroupSearchCurrentPage", 1);
    }
    dispatch("resetCacheResults");
    dispatch("resetResults");
    if (rootState.userAccount && rootState.userAccount.groupId && rootState.userAccount.groupId.length > 0) {
      dispatch("fetchTotalRecordsCount");
      dispatch("fetchGroupSearchResult");
    }
  },
  invokeFilterChange({ commit, dispatch, rootState }, value) {
    if (state.searchRecordsPage !== 1) {
      commit("setGroupSearchCurrentPage", 1);
    }
    dispatch("resetCacheResults");
    dispatch("resetResults");
    if (
      value === 1 &&
      rootState.userAccount &&
      rootState.userAccount.groupId &&
      rootState.userAccount.groupId.length > 0
    ) {
      dispatch("fetchTotalRecordsCount");
      dispatch("fetchGroupSearchResult");
    }
  },
  invokeGroupSelection({ commit, dispatch, rootState }) {
    if (state.searchRecordsPage !== 1) {
      commit("setGroupSearchCurrentPage", 1);
    }
    if (state.isFirstPageLoad) commit("setFirstPageLoadStatus", false);
    dispatch("resetCacheResults");
    dispatch("resetResults");
    if (rootState.userAccount && rootState.userAccount.groupId && rootState.userAccount.groupId.length > 0) {
      dispatch("fetchTotalRecordsCount");
      dispatch("fetchGroupSearchResult");
    }
  },
  invokeDateTypeSelection({ commit, dispatch, rootState }) {
    if (state.searchRecordsPage !== 1) {
      commit("setGroupSearchCurrentPage", 1);
    }
    dispatch("resetCacheResults");
    dispatch("resetResults");
    if (rootState.userAccount && rootState.userAccount.groupId && rootState.userAccount.groupId.length > 0) {
      dispatch("fetchTotalRecordsCount");
      dispatch("fetchGroupSearchResult");
    }
  },
  resetResults({ commit }) {
    commit("setGroupSearchResult", []);
    commit("setTotalRecordsCount", 0);
    commit("setErrorState", { type: "searchRecords", error: null });
    commit("setErrorState", { type: "totalRecords", error: null });
  },
  resetCacheResults({ commit }) {
    commit("resetResultCacheKeyData", { totalRecords: 0, searchRecords: [] }); //reset cached data, since new range selection
    commit("workflowComplaince/resetResultCacheKeyData", { complainceRecords: [] }, { root: true }); //reset cached complaince data, since new range selection
    commit("workflowComplaince/setComplainceResult", { complainceRecords: [] }, { root: true });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
